import React, { Component } from "react";

export default class Logo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoBackgroundColor: "transparent",
      isShowLogo: false,
    };
  }

  componentDidMount() {
    this.setLogoBackgroundColorBasedOnURL();
  }

  setLogoBackgroundColorBasedOnURL() {
    const hostname = window.location.hostname;
    let backgroundColor = "transparent";
    let isShowLogo;

    if (hostname.includes("localhost")) {
      isShowLogo = true;
      backgroundColor = "#D3D3D3";
    } else if (hostname.includes("dev-")) {
      isShowLogo = true;
      backgroundColor = "#00FF00";
    } else if (hostname.includes("rec-")) {
      isShowLogo = true;
      backgroundColor = "#0000FF";
    } else if (hostname.includes("pprd-")) {
      isShowLogo = true;
      backgroundColor = "#FFA500";
    } else {
      isShowLogo = false;
    }

    this.setState({
      logoBackgroundColor: backgroundColor,
      isShowLogo: isShowLogo,
    });
  }

  render() {
    const { logoBackgroundColor, isShowLogo } = this.state;
    const { logoUrl, logoAlt } = this.props;

    return (
      <>
        {isShowLogo && (
          <div className="name-page-block logo">
            <div
              className="logo-bg-color"
              style={{ backgroundColor: logoBackgroundColor }}
            >
              <img
                src={logoUrl}
                className="logo"
                alt={logoAlt}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}
